import { configureStore } from '@reduxjs/toolkit'
import userReducer from '../states/user/user.reducer'

const store = configureStore({
    reducer: {
        User: userReducer,
    },
})

export default store
